<template>
	<div class="score-panel">
		<h3
			v-if="heading"
			class="title is-6 column-title"
			:class="{ 'column-tooltip': tooltip }"
			v-text="heading"
		/>
		<tooltip
			v-if="tooltip"
			class="feature"
			icon="question-circle"
			library="fas"
			position="is-left"
			:tip="tooltip"
			size="is-medium"
		/>
		<div v-if="scoreData">
			<p v-if="subtitle" class="is-size-6">{{ subtitle }}</p>
			<p class="is-size-3">
				<strong>{{ count }} / {{ goal }}</strong>
			</p>
			<progress :class="progressClass" :value="score" max="100">
				{{ score }} %
			</progress>
		</div>
		<div v-else>
			<dc-icon v-if="isFetching" icon="sync" no-margin spin />
			<span v-text="label" />
		</div>
	</div>
</template>

<script>
import sourceMixin from "./sourceMixin";
import tooltip from "../../../components/ListingCard/components/Tooltip";

export default {
	components: { tooltip },
	mixins: [sourceMixin],
	data() {
		return {
			size: 356,
			scoreData: null
		};
	},
	computed: {
		score() {
			return this.scoreData.Label;
			// return this.scoreData ? Math.round(this.scoreData.Percentage) : 0;
		},
		progressClass() {
			return "progress is-large is-" + this.successStatus;
		},
		successStatus() {
			return this.scoreData.Percentage > this.data.successlevel
				? "success"
				: "danger";
		},
		content() {
			return this.data.content || null;
		},
		goal() {
			return this.data.goal;
		},
		count() {
			return this.scoreData.Count;
		},
		heading() {
			return this.data.title;
		},
		subtitle() {
			return this.data.label;
		},
		tooltip() {
			return this.data.tip || null;
		}
	},
	methods: {
		async fetchData() {
			this.isFetching = true;
			this.scoreData = null;
			this.label = "Loading";

			if (!this.isValid(this.source)) {
				this.isFetching = false;
				return;
			}

			await this.fetchSource(this.source).then(
				(response) => {
					this.scoreData = response;
					this.isFetching = false;
					if (!response) {
						this.label = this.errorMessage;
					}
				},
				() => {
					this.label = this.errorMessage;
					this.isFetching = false;
				}
			);
		}
	}
};
</script>

<style scoped>
.score-panel {
	border-right: 1px solid #d5d5d5;
	position: relative;
	padding-right: 10px;
}
.column-tooltip {
	padding-right: 1em;
}
.tooltip {
	position: absolute;
	right: 0;
	top: 0;
}
.is-dashed {
	border-bottom: none;
}
</style>
